@if (data(); as msg) {
    Added <category-item [category]="msg.category" />
}
 